import Img1 from "../assets/images/welcome-img.webp";
import Img2 from "../assets/images/news2.webp";
import Img3 from "../assets/images/news3.webp";
import Img4 from "../assets/images/news4.webp";
export const latestNews = [
  {
    newsHeading: "FAMILY BUSINESS OWNERS",
    img: Img1,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "Running a business is both rewarding and challenging. It comes with the immense satisfaction of blazing your own trail and building something valuable on your own terms. At AFF, we can help you achieve your goals..",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",
    id: 1,
  },
  {
    newsHeading: "FAMILY BUSINESS EMERGING LEADERS",
    img: Img2,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "Working in a family business is both rewarding and challenging. Carving your own place on your terms can be tough. Don’t worry, you’re not alone.We’ll be able to equip you with the knowledge and skills.... ",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",
    id: 2,
  },
  {
    newsHeading: "SUPPORT & NETWORKING",
    img: Img3,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "We actively support family businesses on their journey to multigenerational success by understanding their needs, providing them with relevant learning and connecting them with fellow business owners and advisors. ...",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",

    id: 3,
  },
  {
    newsHeading: "FAMILY BUSINESS ADVISERS",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "Are you a business advisor? Are you interested in advising more familybusinesses? Become an AFF Accredited Adviser and set yourself apart as a specialist in the area of family business.",
    moreDetails:
      "Our seven research themes span the full range of research activities being carried out in the Laboratory and reflect national research priorities. Many themes cover the work of more than one research group, encouraging new associations and cross-disciplinary collaboration. While the core of our research programme is in experimental physics, essential theoretical support is provided by theorists embedded within the astrophysics and high energy physics research groups, while the condensed matter theory group are strongly cross-disciplinary and contribute to most of the themes shown above.",
    tag1: "research",
    tag2: "physics",
    tag3: "education",
    tag4: "science",

    id: 4,
  },
  {
    newsHeading: "Breakthrough ",
    img: Img1,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails: "Researchers at the University of Port ...",
    id: 5,
  },
  {
    newsHeading: "Distinguished ",
    img: Img2,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails: " The department is delighted to welcome  ",
    id: 6,
  },
  {
    newsHeading: "Student Team",
    img: Img3,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails: "A team of physics students from",
    id: 7,
  },
  {
    newsHeading: "Cutting-Edge ",
    img: Img4,
    date: "25 june 2023",
    view: "59",
    comment: "19",
    newsDetails:
      "The Physics Department has invested in state-of-the-art laboratory ",
    id: 8,
  },
];
